import { render, staticRenderFns } from "./world-map-mpmc.vue?vue&type=template&id=32aa3423&scoped=true&"
import script from "./world-map-mpmc.vue?vue&type=script&lang=js&"
export * from "./world-map-mpmc.vue?vue&type=script&lang=js&"
import style0 from "./world-map-mpmc.vue?vue&type=style&index=0&id=32aa3423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa3423",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VFlex,VImg,VLayout,VRow,VSelect,VSwitch})
